module.exports = __webpack_public_path__ + "static/media/screen2-1x.efe0daf8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/Phone/screen2-1x.jpg
// module id = 47
// module chunks = 0